export default function RelatedSliderProgress() {
	return <div className="slider__progress">
	<div className="slider__progress__wrapper">
		<div className="slider__progress__marker" />
	</div>
</div>
}
